import type ModuleButtonsType from '../components/ModuleButtonsType';
import { showDeleteDialog, showDetailsReportingDialog, Utils } from 'app/main/components';
import { showFastAddDialog } from 'app/main/modules/components/FastAddDialog';
import { shareDetailsPage } from 'app/main/components/dialogs/ShareDialog';
import { showAddNotesDialog } from 'app/main/submodules/notes/NotesAddDialog';

import leaveEvents from './LeaveEvents';

const LEAVE_ACCEPTED_ID = 2;
const LEAVE_REJECTED_ID = 4;

export default {
	view: {
		itemButtons: [
			{
				name: 'VIEW_ITEM_LEAVE_ACCEPT',
				icon: 'check-circle-outline',
				color: '#20ab20',
				hidden: ({ authorizer, model }) =>
					authorizer.cannot('update', 'leave') ||
					model.leav_lvst_id === LEAVE_REJECTED_ID ||
					model.leav_lvst_id === LEAVE_ACCEPTED_ID,
				action: params => {
					const modifiedModel = {
						leav_uid: params.model.leav_uid,
						leav_lvst_id: LEAVE_ACCEPTED_ID,
						leav_user_modified_uid: params.userData.user_uid,
						leav_user_assigned_uid: params.userData.user_uid
					};

					Utils.executeStored({
						action: 'st_leave_update',
						data: modifiedModel,
						dispatch: params.dispatch,
						successHandler: () => {
							leaveEvents.onAfterSave({ ...params, model: params.model, modifiedModel });
							params.updateRefresh();
						}
					});
				}
			},
			{
				name: 'VIEW_ITEM_LEAVE_REJECT',
				icon: 'close-circle-outline',
				color: '#ab2020',
				hidden: ({ authorizer, model }) =>
					authorizer.cannot('update', 'leave') ||
					model.leav_lvst_id === LEAVE_REJECTED_ID ||
					model.leav_lvst_id === LEAVE_ACCEPTED_ID,
				action: params => {
					const modifiedModel = {
						leav_uid: params.model.leav_uid,
						leav_lvst_id: LEAVE_REJECTED_ID,
						leav_user_modified_uid: params.userData.user_uid,
						leav_user_assigned_uid: params.userData.user_uid
					};

					Utils.executeStored({
						action: 'st_leave_update',
						data: modifiedModel,
						dispatch: params.dispatch,
						successHandler: () => {
							leaveEvents.onAfterSave({ ...params, model: params.model, modifiedModel });
							params.updateRefresh();
						}
					});
				}
			},
			{
				name: 'VIEW_ITEM_BUTTON_EDIT',
				icon: 'edit',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'leave'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(showFastAddDialog({ module: 'leave', updateRefresh, isUpdate: true, model }))
			},
			{
				name: 'VIEW_ITEM_BUTTON_ADD_COPY',
				icon: 'content-copy',
				iconAdd: true,
				hidden: ({ authorizer }) => authorizer.cannot('create', 'leave'),
				action: ({ model, t }) => {
					const { leav_title } = model;
					Utils.openLink({
						pathname: '/leave/add',
						state: {
							model: { ...model, leav_title: leav_title + t('COPY') }
						}
					});
				}
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_NOTE',
				icon: 'comment-text-multiple-outline',
				iconAdd: true,
				action: ({ model, dispatch }) =>
					dispatch(showAddNotesDialog({ model: { note_table: 'leave', note_table_uid: model.leav_uid } }))
			},
			{
				name: 'VIEW_ITEM_BUTTON_DELETE',
				icon: 'delete',
				color: 'red',
				hidden: ({ authorizer }) => authorizer.cannot('delete', 'leave'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showDeleteDialog({
							module: 'leave',
							id: model.leav_uid,
							title: model.leav_title,
							updateRefresh
						})
					)
			}
		],
		headerButtons: [
			{
				name: 'VIEW_HEADER_BUTTON_NEW',
				icon: 'plus-circle',
				hidden: ({ authorizer }) => authorizer.cannot('create', 'leave'),
				action: () => Utils.openLink({ pathname: '/leave/add' })
			}
		]
	},
	details: {
		headerButtons: [
			// {
			// 	name: 'DETAILS_HEADER_BUTTON_FAVOURITE',
			// 	icon: 'star-outline',
			// 	disabled: () => true,
			// 	action: () => {}
			// },
			{
				name: 'DETAILS_HEADER_BUTTON_SHOW_LOG',
				icon: 'timeline-clock-outline',
				hidden: ({ authorizer }) => authorizer.cannot('view', 'logs'),
				disabled: ({ isEdit }) => isEdit,
				action: ({ switchShowLogs }) => switchShowLogs()
			},
			{
				name: 'VIEW_HEADER_BUTTON_EXPORT',
				icon: 'file-export',
				action: ({ model, dispatch, settings, sysSettings }) =>
					showDetailsReportingDialog({ model, dispatch, settings, sysSettings })
			},
			{
				name: 'DETAILS_HEADER_BUTTON_SHARE',
				icon: 'share-variant',
				action: ({ model, dispatch, settings, t }) => shareDetailsPage({ model, dispatch, settings, t })
			},
			{
				name: 'DETAILS_HEADER_BUTTON_DELETE',
				icon: 'delete',
				color: 'red',
				hidden: ({ authorizer }) => authorizer.cannot('delete', 'leave'),
				action: ({ model, dispatch }) =>
					dispatch(
						showDeleteDialog({
							module: 'leave',
							id: model.leav_uid,
							title: model.leav_title
						})
					)
			}
		],
		fabs: [
			{
				id: 'summary',
				name: 'ACTION_EDIT',
				icon: 'edit',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'leave'),
				action: ({ switchEdit }) => switchEdit()
			}
		]
	}
} as ModuleButtonsType;
